import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadImageComponent } from './upload-image/upload-image.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxDropzoneModule } from 'ngx-dropzone';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { SelectRecordtypeComponent } from './select-recordtype/select-recordtype.component';
import { RouterModule } from '@angular/router';
import { InputMatChipComponent } from './input-mat-chip/input-mat-chip.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { UploadPdfComponent } from './upload-pdf/upload-pdf.component';
import { CustomPreviewImageComponent } from './upload-image/custom-preview-image/custom-preview-image.component'; 

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [UploadImageComponent, SelectRecordtypeComponent, InputMatChipComponent, UploadPdfComponent, CustomPreviewImageComponent],
  imports: [
    CommonModule,  
    FormsModule,
    HttpClientModule,
    NgxDropzoneModule,
    PerfectScrollbarModule,
    RouterModule,

    // Material
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatInputModule, 
    MatSnackBarModule,
    MatTableModule,
    MatChipsModule, 
		MatAutocompleteModule
  ],
  exports: [UploadImageComponent, SelectRecordtypeComponent, InputMatChipComponent, UploadPdfComponent],
  entryComponents: [],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ],
})
export class RdsFormControlInputModule { }
